import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
// import imglogosunny from "../../../assets/common/logo_sunny_03.png";
import imglogosunny from "../../../assets/common/logo_sunny_03.png";

const FloatingButton = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <div className="fixed bottom-[30%] right-0">
      <div
        className="flex flex-col w-full justify-center items-center bg-secondary1 "
        style={{ zIndex: 9999 }}
      >
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.facebook.com/profile.php?id=61568578130590"
          className="cursor-pointer p-2 qhd:q-4"
        >
          <Icon className="h-6 w-6  text-white" icon={"ri:facebook-fill"} />
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/company/idg-australia/"
          className="cursor-pointer p-2 qhd:q-4"
        >
          <Icon className="h-6 w-6  text-white" icon={"ri:linkedin-fill"} />
        </a>
        {/* <a
          target="_blank"
          rel="noreferrer"
          href="https://sunnypearl.com.vn/"
          className="cursor-pointer p-2 qhd:q-4"
        >
          <img className="h-6 w-6 " src={imglogosunny} />
        </a> */}
      </div>
    </div>
  );
};

export default FloatingButton;
